enum Fields {
    Subject = 'Subject',
    Message = 'Message',
}

export default Fields;
